/* eslint-disable func-style, max-len, max-lines, max-params, no-return-assign, no-undef, sort-keys, sort-vars */

import {
  BRACELET_ANSWERS,
  EARRINGS_ANSWERS,
  NECKLACE_ANSWERS,
  RINGS_ANSWERS,
  TREND_ANSWERS
} from "../constants/index.js";
import ExperimentalKindQuestion from "../components/ExperimentalKindQuestion.jsx";
import ExperimentalMetalToneQuestion from "../components/ExperimentalMetalToneQuestion.jsx";
import {Link} from "react-router-dom";
import React from "react";
import StyleSurveyFinish from "../components/StyleSurveyFinish";
import StyleSurveyMetalQuestion from "../components/StyleSurveyMetalQuestion";
import StyleSurveyQuestion from "../components/StyleSurveyQuestion";
import StyleSurveyRingSizeQuestion from "../components/StyleSurveyRingSizeQuestion";
import StyleSurveySignup from "../components/StyleSurveySignup";

const SKIP = {
  "/": null,
  "/necklaces": {
    "surveyFields": {
      "necklaces": false,
      "necklaceCharm": false,
      "necklaceChoker": false,
      "necklaceDelicate": false,
      "necklaceLayered": false,
      "necklaceLongPendant": false,
      "necklaceNaturalStone": false,
      "necklaceShortPendant": false,
      "necklaceStatement": false
    },
    "text": "I don't wear necklaces"
  },
  "/bracelets": {
    "surveyFields": {
      "bracelets": false,
      "braceletDelicateCuff": false,
      "braceletNaturalStone": false,
      "braceletSlider": false,
      "braceletStatementCuff": false
    },
    "text": "I don't wear bracelets"
  },
  "/earrings": {
    "surveyFields": {
      "earrings": false,
      "wearsClimbers": false,
      "wearsDrops": false,
      "wearsJackets": false,
      "wearsHoops": false,
      "wearsHuggies": false,
      "wearsNaturalStone": false,
      "wearsStatement": false,
      "wearsStuds": false
    },
    "text": "I don't wear earrings"
  },
  "/rings": {
    "surveyFields": {
      "rings": false,
      "ringDelicate": false,
      "ringNaturalStone": false,
      "ringSet": false,
      "ringStatement": false,
      "ring4": false,
      "ring5": false,
      "ring6": false,
      "ring7": false,
      "ring8": false,
      "ring9": false,
      "ring10": false,
      "ring11": false,
      "ring12": false
    },
    "text": "I don't wear rings"
  },
  "/trends": {
    "surveyFields": {},
    "text": "Skip"
  },
  "/ring_sizes": {
    "surveyFields": {},
    "text": "Skip"
  },
  "/finish": {
    "surveyFields": {},
    "text": "Skip"
  }
};

const NEXT_QUESTION = {
  "/": "/necklaces",
  "/necklaces": "/bracelets",
  "/bracelets": "/earrings",
  "/earrings": "/rings",
  "/rings": "/trends",
  "/trends": "/ring_sizes",
  "/ring_sizes": "/finish",
  "/finish": "/signup"
};

export default class StyleSurveyHelper {
  constructor (experimentVariants, isRetake = false) {
    this.experimentVariants = experimentVariants || {};
    this.experimentTwoActive = Boolean(
      !isRetake &&
      typeof this.experimentVariants.styleSurveyPartTwo === "number" &&
      this.experimentVariants.styleSurveyPartTwo >= 1
    );

    if (this.experimentTwoActive) {
      SKIP["/kinds"] = {
        "surveyFields": {},
        "text": "Skip this step"
      };
    }

    this.answers = {
      "/": [
        {
          "surveyFields": {"wearsGold": true},
          "image": "gold",
          "prompt": "Gold"
        },
        {
          "surveyFields": {"wearsSilver": true},
          "image": "silver",
          "prompt": "Silver"
        },
        {
          "surveyFields": {"wearsRoseGold": true},
          "image": "rose_gold",
          "prompt": "Rose Gold"
        }
      ],
      "/necklaces": NECKLACE_ANSWERS,
      "/bracelets": BRACELET_ANSWERS,
      "/earrings": EARRINGS_ANSWERS,
      "/rings": RINGS_ANSWERS,
      "/trends": TREND_ANSWERS,
      "/ring_sizes": [
        {
          "surveyFields": {"ring5": true},
          "prompt": "5"
        },
        {
          "surveyFields": {"ring6": true},
          "prompt": "6"
        },
        {
          "surveyFields": {"ring7": true},
          "prompt": "7"
        },
        {
          "surveyFields": {"ring8": true},
          "prompt": "8"
        },
        {
          "surveyFields": {"ring9": true},
          "prompt": "9"
        },
        {
          "surveyFields": {"ring10": true},
          "prompt": "10"
        },
        {
          "surveyFields": {"ring11": true},
          "prompt": "11"
        },
        {
          "surveyFields": {"ring12": true},
          "prompt": "12"
        }
      ],
      "/finish": []
    };

    if (this.experimentTwoActive) {
      this.answers["/kinds"] = [
        {
          "surveyFields": {"necklaces": true},
          "image": "sse2_necklaces",
          "prompt": "Necklaces"
        },
        {
          "surveyFields": {"earrings": true},
          "image": "sse2_earrings",
          "prompt": "Earrings"
        },
        {
          "surveyFields": {"bracelets": true},
          "image": "sse2_bracelets",
          "prompt": "Bracelets"
        },
        {
          "surveyFields": {"rings": true},
          "image": "sse2_rings",
          "prompt": "Rings"
        }
      ];
    }

    this.surveyFields = {
      "/": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/"]),
      "/kinds": [],
      "/necklaces": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/necklaces"]),
      "/bracelets": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/bracelets"]),
      "/earrings": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/earrings"]),
      "/rings": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/rings"]),
      "/trends": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/trends"]),
      "/ring_sizes": StyleSurveyHelper.getSurveyFieldsByAnswers(this.answers["/ring_sizes"]),
      "/finish": [
        "buyerQuestion1",
        "buyerQuestion1Shown",
        "buyerQuestion2",
        "buyerQuestion2Shown",
        "buyerQuestion3",
        "buyerQuestion3Shown",
        "buyerQuestion4",
        "buyerQuestion4Shown",
        "openQuestion1"
      ],
      "/signup": []
    };

    if (this.experimentTwoActive) {
      this.surveyFields["/kinds"] = [
        "necklaces",
        "earrings",
        "bracelets",
        "rings"
      ];
    }

    this.nextQuestion = {
      "/": "/necklaces",
      "/necklaces": "/bracelets",
      "/bracelets": "/earrings",
      "/earrings": "/rings",
      "/rings": "/trends",
      "/trends": "/ring_sizes",
      "/ring_sizes": "/finish",
      "/finish": "/signup"
    };

    if (this.experimentTwoActive) {
      this.nextQuestion["/"] = "/kinds";
      this.nextQuestion["/kinds"] = "/finish";
    }

    this.prevQuestion = {
      "/": null,
      "/necklaces": "/",
      "/bracelets": "/necklaces",
      "/earrings": "/bracelets",
      "/rings": "/earrings",
      "/trends": "/rings",
      "/ring_sizes": "/trends",
      "/finish": "/ring_sizes",
      "/signup": "/finish"
    };

    if (this.experimentTwoActive) {
      this.prevQuestion["/finish"] = "/kinds";
    }

    this.multiSelect = {
      "/": true,
      "/necklaces": true,
      "/bracelets": true,
      "/earrings": true,
      "/rings": true,
      "/trends": true,
      "/ring_sizes": true
    };

    if (this.experimentTwoActive) {
      this.multiSelect["/kinds"] = true;
    }

    this.answerClass = {
      "/": "response",
      "/necklaces": "response",
      "/bracelets": "response",
      "/earrings": "response",
      "/rings": "response",
      "/trends": "response",
      "/ring_sizes": "circle"
    };

    this.component = {
      "/": StyleSurveyMetalQuestion,
      "/necklaces": StyleSurveyQuestion,
      "/bracelets": StyleSurveyQuestion,
      "/earrings": StyleSurveyQuestion,
      "/rings": StyleSurveyQuestion,
      "/trends": StyleSurveyQuestion,
      "/ring_sizes": StyleSurveyRingSizeQuestion,
      "/finish": StyleSurveyFinish,
      "/signup": StyleSurveySignup
    };

    if (this.experimentVariants.styleSurveyPartOne === 1) {
      this.component["/"] = ExperimentalMetalToneQuestion;
    }

    if (this.experimentTwoActive) {
      this.component["/kinds"] = ExperimentalKindQuestion;
    }
  }

  getHeader (onAnswer) {
    const header = {
      "/": StyleSurveyHelper.headerText("Which metal tones are you interested in receiving?", true, "/", onAnswer),
      "/necklaces": StyleSurveyHelper.headerText("Which necklace styles do you prefer?", true, "/necklaces", onAnswer),
      "/bracelets": StyleSurveyHelper.headerText("Which bracelet styles do you prefer?", true, "/bracelets", onAnswer),
      "/earrings": StyleSurveyHelper.headerText("Which earring styles do you prefer?", true, "/earrings", onAnswer),
      "/rings": StyleSurveyHelper.headerText("Which ring styles do you prefer?", true, "/rings", onAnswer),
      "/trends": StyleSurveyHelper.headerText("Which jewelry trends are you open to trying?", true, "/trends", onAnswer),
      "/ring_sizes": StyleSurveyHelper.headerText("Which ring size(s) do you wear?", true, "/ring_sizes", onAnswer),
      "/finish": StyleSurveyHelper.headerText("Anything else you want your stylist to know?", false, "/finish", onAnswer),
      "/signup": StyleSurveyHelper.headerText("Save your preferences and we'll start building your first set!", false, "/signup", onAnswer)
    };

    if (this.experimentVariants.styleSurveyPartOne === 1) {
      header["/"] = StyleSurveyHelper.headerText("Which metal tones do you wear?", false, "/", onAnswer);
    }

    if (this.experimentTwoActive) {
      header["/kinds"] = StyleSurveyHelper.headerText("Which types of jewelry are you excited to try?", true, "/kinds", onAnswer);
      header["/finish"] = StyleSurveyHelper.headerText("Anything else you'd like your stylist to know?", false, "/finish", onAnswer);
    }
    return header;
  }

  static headerText (question, multiSelect, path, onAnswer = null) {
    function handleSkipClick () {
      $("li.progress_step:not(.filled)").first().addClass("filled");
      scroll(0, 0);
      document.activeElement.blur();

      if (onAnswer) {
        onAnswer(SKIP[path].surveyFields);
      }
    }

    return multiSelect
      ? (
        <div>
          <h1 className="left styled_h2">
            {question}
          </h1>
          <div className="question-skip mb32 mt16">
            <span className="left">
                  (Select all that apply)
            </span>
            <span className="right">
              {path !== "/" &&
              <Link
                className="inline-block skip-message"
                onClick={handleSkipClick}
                to={`/new${NEXT_QUESTION[path]}`}
              >
                {SKIP[path] ? SKIP[path].text : null}
              </Link>
              }
            </span>
          </div>
        </div>)
      : (
        <h1 className="left styled_h2">
          {question}
        </h1>);
  }

  static camelizeSurvey (survey) {
    for (const surveyField of Object.entries(survey)) {
      const originalKey = surveyField.shift();

      let key = originalKey.split("_").map(substr => substr[0].toUpperCase() + substr.substr(1)).join("");
      key = key[0].toLowerCase() + key.substr(1);

      delete survey[originalKey];
      survey[key] = surveyField.shift();
    }
  }

  static snakeizeSurvey (survey) {
    const snakeSurvey = {};
    for (const surveyField of Object.entries(survey)) {
      const string = surveyField.shift();
      const words = string.split(/(?=[A-Z])/).join("_").split(/\d/).join("").toLowerCase();
      const number = string.split(/\D/).join("");

      const key = [
        words,
        number
      ].filter(el => el !== "").join("_");

      snakeSurvey[key] = surveyField.shift();
    }
    return snakeSurvey;
  }

  static getSurveyFieldsByAnswers (answers) {
    return (
      answers.
        map(answer => Object.keys(answer.surveyFields)).
        reduce((fields, field) => {
          field.forEach(fieldKey => fields.push(fieldKey));

          return fields;
        }, [])
    );
  }

  getQuestionHeader (path, handleAnswer) {
    const question = path ? `/${path}` : "/";
    return this.getHeader(handleAnswer)[question];
  }

  getQuestionData (endpoint, path, survey) {
    const question = path ? `/${path}` : "/";
    const nextQuestion = this.nextQuestion[question]
      ? `/${endpoint}${this.nextQuestion[question]}`
      : null;
    const prevQuestion = this.prevQuestion[question]
      ? `/${endpoint}${this.prevQuestion[question]}`
      : null;
    const surveyFields = this.surveyFields[question];

    if (!surveyFields) {
      throw new Error(`Error getting style survey data on path "${path}". Is this path correct?`);
    }

    const surveyFieldsObj = {}; // eslint-disable-line one-var
    surveyFields.forEach(key => (surveyFieldsObj[key] = survey[key]));

    const response = { // eslint-disable-line one-var
      "answerClass": this.answerClass[question],
      "answers": this.answers[question],
      "component": this.component[question],
      "header": this.getHeader()[question],
      "multiSelect": this.multiSelect[question],
      nextQuestion,
      prevQuestion,
      "skip": SKIP[question],
      "surveyFields": surveyFieldsObj
    };

    return response;
  }

  removeRingSizeQuestion () {
    this.nextQuestion["/trends"] = "/finish";
    this.prevQuestion["/finish"] = "/trends";
  }

  addRingSizeQuestion () {
    this.nextQuestion["/trends"] = "/ring_sizes";
    this.prevQuestion["/finish"] = "/ring_sizes";
  }
}

export const getPageTitle = (pathname) => {
  switch (true) {
  case pathname.includes("/necklaces"):
    return "Rockbox: Style Survey | Necklaces";
  case pathname.includes("/bracelets"):
    return "Rockbox: Style Survey | Bracelets";
  case pathname.includes("/earrings"):
    return "Rockbox: Style Survey | Earrings";
  case pathname.includes("/rings"):
    return "Rockbox: Style Survey | Rings";
  case pathname.includes("/trends"):
    return "Rockbox: Style Survey | Trends";
  case pathname.includes("/ring_sizes"):
    return "Rockbox: Style Survey | Ring Sizes";
  case pathname.includes("/finish"):
    return "Rockbox: Style Survey | Finish";
  case pathname.includes("/signup"):
    return "Rockbox: Style Survey | Sign Up";
  default:
    return "Rocksbox: Style Survey";
  }
};
